/**
 * Eventos de producto desde el tema (ADR 150).
 *
 * Una sola implementación para todo el storefront: el drawer la usa y el hero de
 * la landing también. Estaba escrita dos veces y dos copias de "dispara y olvida"
 * se separan en cuanto una cambie.
 *
 * Dispara y olvida, con `keepalive` porque varios de estos eventos ocurren justo
 * cuando la página se está yendo. Solo en la tienda de verdad: desde el servidor
 * de desarrollo ensuciaría las métricas de producción.
 *
 * `metadata` es opcional. Hasta el proyecto Bounty el helper solo sabía mandar
 * `event`, `surface` y `target`, y por eso `product_events.metadata` llegaba
 * VACÍA en todo lo que sale del tema: el endpoint sí la acepta, pero nadie se
 * la mandaba. El servidor descarta cualquier metadata de más de 1,024 bytes
 * entera —no la recorta—, así que quien mande listas tiene que recortarlas
 * antes; `vaultMetadataFaltantes` lo hace para los faltantes de una lista.
 */
window.vaultEvento = (function () {
  var ENDPOINT = 'https://cards.the-vault.mx/api/events';
  var MIDIENDO = location.hostname === 'the-vault.mx';

  return function registrar(evento, destino, metadata) {
    if (!MIDIENDO) return;
    try {
      var cuerpo = { event: evento, surface: 'storefront', target: destino };
      if (metadata && typeof metadata === 'object' && !Array.isArray(metadata)) {
        cuerpo.metadata = metadata;
      }
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cuerpo),
        credentials: 'include',
        keepalive: true,
      }).catch(function () {});
    } catch (e) {
      /* medir nunca puede tirar la página */
    }
  };
})();

/**
 * La metadata de "qué faltó" de una lista: `{pedidas, faltantes,
 * faltantes_nombres}` que SIEMPRE cabe en el tope del endpoint (1,024 bytes).
 *
 * Los conteos nunca se pierden: lo que se sacrifica son nombres. Cada nombre se
 * trunca a 40 caracteres y se van agregando mientras el JSON quepa; si no caben
 * todos, `faltantes_nombres_omitidos` dice cuántos se quedaron fuera, para que
 * quien lea la tabla sepa que la lista está incompleta y no lo confunda con "solo
 * faltaron estas".
 *
 * Se mide en bytes UTF-8, más estricto que el `.length` con el que compara el
 * servidor: un acento son dos bytes y una sola unidad de `.length`.
 */
window.vaultMetadataFaltantes = (function () {
  var TOPE_BYTES = 1024;
  var LARGO_NOMBRE = 40;

  function bytes(texto) {
    if (typeof TextEncoder === 'function') return new TextEncoder().encode(texto).length;
    return unescape(encodeURIComponent(texto)).length;
  }

  function entero(valor) {
    var n = Math.round(Number(valor));
    return isFinite(n) && n > 0 ? n : 0;
  }

  function limpiar(nombre) {
    return String(nombre == null ? '' : nombre).replace(/\s+/g, ' ').trim();
  }

  function recortar(limpio) {
    return limpio.length > LARGO_NOMBRE ? limpio.slice(0, LARGO_NOMBRE - 1) + '…' : limpio;
  }

  return function metadataDeFaltantes(pedidas, faltantes, nombres, extra) {
    // Se deduplica por el nombre COMPLETO y se trunca después: truncando antes,
    // dos cartas distintas con el mismo arranque se volvían una sola.
    var vistos = [];
    var unicos = [];
    (Array.isArray(nombres) ? nombres : []).forEach(function (nombre) {
      var limpio = limpiar(nombre);
      if (!limpio || vistos.indexOf(limpio) !== -1) return;
      vistos.push(limpio);
      unicos.push(recortar(limpio));
    });

    // `extra` son campos cortos del llamador (p. ej. `origen`). Entran al
    // cálculo del tope: agregarlos después podía empujar el JSON fuera.
    function armar(lista, omitidos) {
      var objeto = { pedidas: entero(pedidas), faltantes: entero(faltantes), faltantes_nombres: lista };
      if (omitidos > 0) objeto.faltantes_nombres_omitidos = omitidos;
      if (extra && typeof extra === 'object') {
        Object.keys(extra).forEach(function (clave) {
          if (!(clave in objeto)) objeto[clave] = extra[clave];
        });
      }
      return objeto;
    }

    var aceptados = [];
    for (var i = 0; i < unicos.length; i++) {
      var candidato = armar(aceptados.concat(unicos[i]), unicos.length - (i + 1));
      if (bytes(JSON.stringify(candidato)) > TOPE_BYTES) break;
      aceptados.push(unicos[i]);
    }

    return armar(aceptados, unicos.length - aceptados.length);
  };
})();
